export default __webpack_public_path__ + "media/titles/title_4_locale_it-ec8d5f12.png";